import React, { Component } from 'react';
import {Row,Col,Form} from 'react-bootstrap';

import {URL_IMG} from '../../../configs/urlConfigs';
import {MSG_REQUIRED} from '../../../configs/msgConfigs';
import PhoneInput from 'react-phone-input-2'

import {LBL_COMPANY_INFO, LBL_COMPANY_NAME, LBL_COMPANY_CONTACT_NUM, LBL_COMPANY_REG_NUM, LBL_COMPANY_EMAIL, LBL_WEBSITE, LBL_VAT_NUMBER, LBL_VAT_TAX, LBL_SELECT, LBL_SAVE, LBL_SECTOR, LBL_SUB_SECTOR} from '../../../configs/labelConfigs';
import {PHONE_ISD_CODE, PHONE_ISD_NUM} from '../../../configs/staticConfigs'; 

class CompanyInfo extends Component {    

    uploadLogoFile() {
        document.getElementById('uploadLogo').click(); 
    }

  
    render(){
        const { sectors,subSectors,affiliateData,formErrors,imgUrl,logoLabel,isLogoValid} = this.props; 
        let logoUrl = require('../../../'+URL_IMG+'affiliate-profile-new.png');
        if(imgUrl){
            logoUrl = imgUrl;
        }
        let companyName = ''; 
        if(this.props.hasOwnProperty('showNameInHeader')) companyName = this.props.showNameInHeader;
        return(
            <Form onSubmit={e => this.props.saveFormData(e)} encType="multipart/form-data">
                <Form.Group>
                    <div className="box">
                        <div className="tab-head">
                            <h6>{LBL_COMPANY_INFO} {(companyName) && <span>{' - '+companyName}</span>} </h6>
                        </div> 
                        <div className="box-content">
                            <Row>     
                                <Col md={6} className=" text-center">                                  
                                    <div className="company-logo">
                                        <img src={logoUrl} alt="Company Name" style={{cursor:'pointer'}} onClick={this.uploadLogoFile}  />                                                      
                                        <p className={isLogoValid?'logo-txt':'text-red logo-txt'}><small>{logoLabel}</small></p>               
                                        <label htmlFor="uploadLogo"><i className="las la-pen"></i></label>
                                        <input type="file" name="logo" onChange={this.props.onHandleChange} id="uploadLogo" accept=".jpeg, .jpg, .png, .gif " />
                                    </div>
                                </Col> 
                                
                                <Col md={6}>
                                    <Row>
                                        <Col md={12}>
                                            <div className="form-group">
                                                <label>{LBL_COMPANY_NAME}</label>
                                                <div className="text-input"><input type="text" className={formErrors.companyName.length >0 ? "input-error" : ''} onChange={this.props.onHandleChange} name="companyName" value={affiliateData.companyInfo.companyName || ''} maxLength={50} tabIndex="1" autoFocus={true} />
                                                </div>
                                                {formErrors.companyName.length >0 && formErrors.companyName!==MSG_REQUIRED && (
                                                    <div className="text-red left-align text-12">{formErrors.companyName}</div>
                                                )} 
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}>
                                            <div className="form-group">
                                                <label>{LBL_COMPANY_CONTACT_NUM}</label>
                                                <PhoneInput 
                                                  country={PHONE_ISD_CODE}
                                                  inputProps={{
                                                    name: 'companyContactNum',
                                                    tabIndex: "2",
                                                  }}
                                                  value={affiliateData.companyInfo.companyContactNum || PHONE_ISD_NUM}
                                                  onChange={this.props.onPhoneInputChange} 
                                                />
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row> 
                                        <Col md={12}>
                                            <div className="form-group">
                                                <label>{LBL_COMPANY_REG_NUM}</label>
                                                <div className="input-input"><input type="text" onChange={this.props.onHandleChange} name="companyRegNum" value={affiliateData.companyInfo.companyRegNum || ''} tabIndex="3"  /></div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>                
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_COMPANY_EMAIL}</label>
                                        <div className="input email-input"><input type="email" className={formErrors.companyEmail.length >0 ? "input-error" : ''}  onChange={this.props.onHandleChange} name="companyEmail" value={affiliateData.companyInfo.companyEmail || ''} maxLength={120} tabIndex="4" /></div>
                                    </div>
                                </Col>
                                <Col md={6}> 
                                    <div className="form-group">
                                        <label>{LBL_WEBSITE}</label>
                                        <div className="input weburl-input">
                                            <input className={formErrors.websiteUrl.length >0 ? "input-error" : ''} type="text" onChange={this.props.onHandleChange} name="websiteUrl" value={affiliateData.companyInfo.websiteUrl || ''} maxLength={128} autoComplete="off" tabIndex="5"   />
                                        </div>
                                        {formErrors.websiteUrl.length >0 && (
                                            <div className="text-red left-align text-12">{formErrors.websiteUrl}</div>
                                        )} 
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_VAT_NUMBER}</label>
                                        <div className="input-input"><input type="text" onChange={this.props.onHandleChange} name="vatNum" value={affiliateData.companyInfo.vatNum || ''} tabIndex="6" /></div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_VAT_TAX}</label>
                                        <div className="input-input"><input type="text" onChange={this.props.onHandleChange} name="vatTax" className={formErrors.vatTax.length >0 ? "input-error" : ''} value={affiliateData.companyInfo.vatTax || ''} tabIndex="7" /></div>
                                    </div>
                                </Col>
                            </Row>
                            <Row>                                
                                <Col md={6}>
                                    <div className="form-group"> 
                                        <label>{LBL_SECTOR}</label>
                                        <div className="form-group select-input">
                                            <select onChange={this.props.onHandleChange} name="sector" className={formErrors.sector.length >0 ? "input-error" : ''} value={affiliateData.companyInfo.sector} tabIndex="8">
                                                <option value="0">{LBL_SELECT}</option>
                                                {Array.isArray(sectors) && sectors.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}  
                                            </select>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label>{LBL_SUB_SECTOR}</label>
                                        <div className="form-group select-input">
                                            <select onChange={this.props.onHandleChange} name="subSector" className={formErrors.subSector.length >0 ? "input-error" : ''} value={affiliateData.companyInfo.subSector} tabIndex="9" >
                                                <option value="0">{LBL_SELECT}</option>
                                                {Array.isArray(subSectors) && subSectors.filter(x => x.sector === Number(affiliateData.companyInfo.sector)).map((item) => <option key={item.id} value={item.id}>{item.name}</option>)} 
                                            </select>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <div className="clearfix">
                                <button type="submit" className="btn btn-primary float-right" tabIndex="10">{LBL_SAVE}</button>
                            </div>
                        </div>
                    </div>
                </Form.Group>  
            </Form>
        )
    }
}

export default CompanyInfo;